import Folder from './folder'
export default Folder



/** WEBPACK FOOTER **
 ** ./es2015/controls/folder/index.js
 **/